const getters = {
  getIsToken (store) {
    return store.isToken
  },
  getPathTemporal (store) {
    return store.pathTemporal
  },
  getIsTestUser (state) {
    return state.isTestUser
  },
  getLoginHelper (state) {
    return state.loginHelper
  }
}

export default getters
